import {FormikHelpers} from 'formik';
import {notify} from '@gemcook/notification';
import api from '@api';

export const updateSetting = async (
  values: any,
  formikHelpers: FormikHelpers<any>,
  me: MeStore
) => {
  try {
    await api.teams.update(me.teamId, values);
    notify('自動送信設定の更新に成功しました', 'success');
  } catch (error) {
    notify('自動送信設定の更新に失敗しました', 'error');
  }

  formikHelpers.setSubmitting(false);
};
